<template>
  <div class="footer__item footer-newsletter newsletter-footer">
    <form :action="formActionUrl" method="post" @submit.prevent="validateAndSend">
      <slot name="title"/>
      <div class="footer-newsletter-form">
        <label for="newsletter-sign-up-footer" class="is-sr-only">{{ emailPlaceholder }}</label>
        <input
          v-model="emailField"
          @blur="checkEmailValid(), isEmailEmpty()"
          type="email"
          :class="{ 'input-error': hasErrorValidEmail || hasErrorEmail }"
          class="newsletter-footer__input"
          id="newsletter-sign-up-footer"
          autocomplete="off"
          :placeholder="emailPlaceholder"
          :aria-describedby="emailDescribedby">
        <button type="submit"
                @click="checkEmailValid(), isEmailEmpty()"
                :class="{ 'disabled': !isSubmitEnabled }"
                class="btn__wrapper">{{ submitBtnText }}</button>
      </div>
      <div v-if="hasErrorValidEmail" class="newsletter-footer__status--error">{{ validationMsg.emailFormat }}</div>
      <div v-if="hasErrorEmail" class="newsletter-footer__status--error">{{ validationMsg.emailEmpty }}</div>
      <slot name="privacy"/>
    </form>
  </div>
</template>

<script>

  import { setCookie } from '@Foundation/utilities/cookies';

  export default {
    name: 'newsletter-sign-up-footer',
    props: {
      formActionUrl: { type: String, default: '' },
      newsletterFormParams: { type: Object, default: () => {
        return {
          newsletterEmailCookie: 'mdc-newsletter-email',
          newsletterEmailCookieValue: 'janedoe@loreal.com',
          registrationSubSourceCookie: 'mdc-registration-sub-source',
          registrationSubSourceValue: 'In-Page',
        };
      } },
      successMsg: { type: String, default: '' },
      errorMsg: { type: String, default: '' },
      emailPlaceholder: { type: String, default: '' },
      submitBtnText: { type: String, default: '' },
      validationMsg: { type: Object, default: () => {
        return {
          emailFormat: 'Please use valid email format.',
          emailEmpty: 'Please enter your email address.',
          terms: 'Please accept the terms of use.',
        };
      } }
    },
    data() {
      return {
        isSubmitEnabled: false,
        emailField: '',
        hasErrorValidEmail: false,
        hasErrorEmail: false,
        enableFormRedirect: false
      };
    },
    computed: {
      fetchUrl() {
        return this.formActionUrl;
      },
      canSubmit() {
        return !!this.emailField && !this.hasErrorValidEmail;
      },
      emailDescribedby() { 
        if (this.hasErrorValidEmail || this.hasErrorEmail) { 
            return 'newsletter email error'; 
        }
        return ''; // Return an empty string instead of false
      }
    },
    watch: {
      canSubmit(value) {
        this.isSubmitEnabled = value;
      }
    },
    methods: {
      isEmailEmpty() {
        if (this.emailField === '') {
          this.hasErrorEmail = true;
        } else {
          this.hasErrorEmail = false;
        }
      },
      validateEmail(email) {
        const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return re.test(String(email).toLowerCase());
      },
      checkEmailValid() {
        if (!this.validateEmail(this.emailField) && this.emailField !== '') {
          this.hasErrorValidEmail = true;
        } else {
          this.hasErrorValidEmail = false;
        }
      },
      formRedirect() {
        if (!!this.emailField && this.isSubmitEnabled) {
          this.enableFormRedirect = true;
          const url = this.fetchUrl;
          /* istanbul ignore else */
          setCookie(this.newsletterFormParams.newsletterEmailCookie, this.emailField, '1');
          setCookie(this.newsletterFormParams.registrationSubSourceCookie, this.newsletterFormParams.registrationSubSourceValue, '1');
          window.location.assign(url);
        }
      },
      validateAndSend() {
        this.isEmailEmpty();
        this.formRedirect();
      }
    }
  };
</script>

<style src="./newsletter-footer.scss" lang="scss"></style>
